import { render, staticRenderFns } from "./powerConsumption.vue?vue&type=template&id=13965624"
import script from "./powerConsumption.vue?vue&type=script&lang=js"
export * from "./powerConsumption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports